/*
 * PersonalWidgets Messages
 *
 * This contains all the text for the PersonalWidgets component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  entripName: {
    id: 'application_form.entripName',
    defaultMessage: 'Тадбиркорлик субъекти номи',
  },
  formError: {
    id: 'application_form.formError',
    defaultMessage: 'Хизматдан фойдаланиб бўлмади. Кейинроқ уриниб кўринг.',
  },
  phoneError: {
    id: 'application_form.phoneError',
    defaultMessage: 'Телефон рақамини тўғри киритинг.',
  },
  phoneLabel: {
    id: 'application_form.phoneLabel',
    defaultMessage: 'Телефон (+998xxxxxxxxx)',
  },
  answerOnlyElectron: {
    id: 'application_form.answerOnlyElectron',
    defaultMessage: 'Мурожаатга фақат электрон шаклда жавоб берилишига розиман',
  },
  answerElectronAndWritten: {
    id: 'application_form.answerElectronAndWritten',
    defaultMessage: 'Мурожаатга Қоғоз ва электрон шаклда жавоб берилишига розиман',
  },
  agreementHint: {
    id: 'application_form.agreementHint',
    defaultMessage:
      'Фойдаланиш <a href={link} id={id} data-toggle={dataToggle} data-target={dataTarget}>қоидалари</a> билан танишдим',
  },
  yearError: {
    id: 'application_form.yearError',
    defaultMessage: 'Тўғилган йилингизни тўғри форматда киритинг: (dd.mm.19xx/20xx)',
  },
  emailError: {
    id: 'application_form.emailError',
    defaultMessage: 'Тўғри электрон почта манзилини кўрсатинг',
  },
  surname: {
    id: 'application_form.surname',
    defaultMessage: 'Фамилия',
  },
  name: {
    id: 'application_form.name',
    defaultMessage: 'Исм',
  },
  secondName: {
    id: 'application_form.secondName',
    defaultMessage: 'Отасининг исми',
  },
  fileError: {
    id: 'application_form.fileError',
    defaultMessage: '5 мбдан катта файл юклаш мумкин эмас!',
  },
  fileError2: {
    id: 'application_form.fileError2',
    defaultMessage: 'Бундай форматдаги файлни юклаш мумкин эмас!',
  },
  captchaError: {
    id: 'application_form.captchaError',
    defaultMessage: 'Жавоб нотўғри. Бошқаттан уриниб кўринг.',
  },
  captchaHint: {
    id: 'application_form.captchaHint',
    defaultMessage: 'Расмдаги рақамларни киритинг',
  },
  region: {
    id: 'application_form.region',
    defaultMessage: 'Ҳудуд',
  },
  district: {
    id: 'application_form.district',
    defaultMessage: 'Туман (шаҳар)',
  },
  country: {
    id: 'application_form.country',
    defaultMessage: 'Давлат',
  },
  gender: {
    id: 'application_form.gender',
    defaultMessage: 'Жинс',
  },
  birthdate: {
    id: 'application_form.birthdate',
    defaultMessage: 'Туғилган сана',
  },
  isSecret: {
    id: 'application_form.isSecret',
    defaultMessage: 'Мурожаат ошкоралиги',
  },
  address: {
    id: 'application_form.address',
    defaultMessage: 'Манзил',
  },
  email: {
    id: 'application_form.email',
    defaultMessage: 'Электрон почта',
  },
  feedback_email: {
    id: 'application_form.feedback_email',
    defaultMessage: 'Электронная почта (необязательно)',
  },
  phone: {
    id: 'application_form.phone',
    defaultMessage: 'Телефон',
  },
  entrip: {
    id: 'application_form.entrip',
    defaultMessage: 'Тадбиркор',
  },
  entripHint: {
    id: 'application_form.entripHint',
    defaultMessage: 'Тадбиркорлик субъекти сифатида мурожаат қилаётган бўлсангиз ушбу катакчани белгиланг',
  },
  status: {
    id: 'application_form.status',
    defaultMessage: 'Мақом',
  },
  fileLabel: {
    id: 'application_form.fileLabel',
    defaultMessage: 'Қўшимча файл',
  },
  fileHint: {
    id: 'application_form.fileHint',
    defaultMessage: 'Қўшимча файлни кўрсатинг <br/>(хажми  5мб гача)',
  },
  applicationLabel: {
    id: 'application_form.applicationLabel',
    defaultMessage: 'Мурожаат матни',
  },
  applicationHint: {
    id: 'application_form.applicationHint',
    defaultMessage:
      'Мурожаатингиз тезкор равишда ҳал этилишини истасангиз, ҳар бир масала бўйича алоҳида мурожаат йўллашингизни ҳамда мазкур мурожаатни лўнда, оддий ва равон тилда баён этишингизни сўраймиз!',
  },
  sendButton: {
    id: 'application_form.sendButton',
    defaultMessage: 'Жўнатиш',
  },
  notAccepted: {
    id: 'application_form.notAccepted',
    defaultMessage: 'Тақиқланган файл',
  },
  maxNumberOverflow: {
    id: 'application_form.maxNumberOverflow',
    defaultMessage: 'Жами файллар сони 10 тадан ошмаслиги лозим',
  },
  uploadFile: {
    id: 'application_form.uploadFile',
    defaultMessage: 'Файлни юкланг',
  },
  phoneReal: {
    id: 'application_form.phoneReal',
    defaultMessage: 'Telefon raqami tasdiqlandi!',
  },
  getCode: {
    id: 'application_form.getCode',
    defaultMessage: 'Kod olish',
  },
  enterCode: {
    id: 'application_form.enterCode',
    defaultMessage: 'Tekshiruv kodini kiriting',
  },
  resendCode: {
    id: 'application_form.resendCode',
    defaultMessage: 'Qayta yuborish',
  },
  codeSendTo: {
    id: 'application_form.codeSendTo',
    defaultMessage: 'Tekshiruv kodi ushbu raqamga yuborildi',
  },
  fileSize: {
    id: 'application_form.fileSize',
    defaultMessage: 'Файлнинг ҳажми 10 мб дан ва жами файллар сони 10 тадан ошмаслиги лозим',
  },
  fileSizeValidation: {
    id: 'application_form.fileSizeValidation',
    defaultMessage: 'Файл «{file_name}» превышает допустимый размер. Загружаемый файл не должен превышать 10 Мб',
  },
  fileUploaded: {
    id: 'application_form.fileUploaded',
    defaultMessage: 'Файл юкланди',
  },
  error: {
    id: 'application_form.error',
    defaultMessage: 'Хато!',
  },
  secretInfo: {
    id: 'application_form.secretInfo',
    defaultMessage: 'Мурожаат ва мурожаатчи тўғрисида маълумотларнинг ошкоралиги',
  },
  makhalla: {
    id: 'application_form.makhalla',
    defaultMessage: 'Маҳалла',
  },
  man: {
    id: 'application_form.man',
    defaultMessage: 'Эркак',
  },
  woman: {
    id: 'application_form.woman',
    defaultMessage: 'Аёл',
  },
  yes: {
    id: 'application_form.yes',
    defaultMessage: 'Ҳа',
  },
  no: {
    id: 'application_form.no',
    defaultMessage: 'Йўқ',
  },
  showPhone: {
    id: 'application_form.showPhone',
    defaultMessage: "Murojaat yo'llash uchun telefon raqamingizni kiriting.",
  },
  unknownError: {
    id: 'application_form.unknownError',
    defaultMessage: 'Хатолик юз берди!',
  },
  applicationSuccess: {
    id: 'application_form.applicationSuccess',
    defaultMessage: `Сизнинг мурожаатингиз {title}га муваффақиятли юборилди!`,
  },
  applicationAlreadySuccess: {
    id: 'application_form.applicationAlreadySuccess',
    defaultMessage: `Сиз ушбу мурожаатни бугун юборилган едиз!`,
  },

  pleaseSave: {
    id: 'application_form.pleaseSave',
    defaultMessage: 'Диққат!!! Қуйидаги малумотларни сақлаб олинг',
  },
  applicationNo: {
    id: 'application_form.applicationNo',
    defaultMessage: `Мурожаат рақами`,
  },
  applicationToken: {
    id: 'application_form.applicationToken',
    defaultMessage: `Текшириш коди`,
  },
  authority: {
    id: 'application_form.authority',
    defaultMessage: `Ташкилот номи`,
  },
  request_no: {
    id: 'application_form.request_no',
    defaultMessage: `Мурожаат рақами`,
  },
  note_title: {
    id: 'application_form.note_title',
    defaultMessage: 'Шахсингизни тасдиқловчи маълумотларни киритинг',
  },
  note_warning: {
    id: 'application_form.note_warning',
    defaultMessage:
      'Сиз томондан киритилган шахсга доир маълумотлар учинчи шахсларга ошкор этилмайди ва тарқатилмайди!',
  },
  note_text: {
    id: 'application_form.note_text',
    defaultMessage: 'Шахсни тасдиқловчи маълумотларни киритиш қуйидаги афзалликларга эга:',
  },
  note_list_item_one: {
    id: 'application_form.note_list_item_one',
    defaultMessage: 'мурожаат юбориш шаклининг кўплаб қисмлари автоматик равишда тўлдирилади',
  },
  note_list_item_two: {
    id: 'application_form.note_list_item_two',
    defaultMessage:
      'киритилган мурожаат номингизда сақланади ва уни исталган пайтда id.egov.uz хизмати орқали тизимга кириб топишингиз мумкин бўлади',
  },
  note_list_item_three: {
    id: 'application_form.note_list_item_three',
    defaultMessage: 'мурожаатни асоссиз равишда кўрмасдан қолдириш ҳолатларининг олди олинади',
  },
  preliminary_form_title: {
    id: 'application_form.preliminary_form_title',
    defaultMessage: 'Шахсни тасдиқловчи ҳужжат маълумотлари*:',
  },
  passport_series: {
    id: 'application_form.passport_series',
    defaultMessage: 'Серияси',
  },
  passport_number: {
    id: 'application_form.passport_number',
    defaultMessage: 'Рақами',
  },
  passport_helper_text: {
    id: 'application_form.passport_helper_text',
    defaultMessage:
      '*Шахсни тасдиқловчи ҳужжат сифатида фуқаролик паспорти, ID-карта ва хорижга чиқиш паспортидан фойдаланиш мумкин',
  },
  dd_mm_yy: {
    id: 'application_form.dd_mm_yy',
    defaultMessage: 'кун | ой | йил',
  },
  captcha_label: {
    id: 'application_form.captcha_label',
    defaultMessage: 'Введите число из картинки',
  },
  preliminary_form_link: {
    id: 'application_form.preliminary_form_link',
    defaultMessage: 'Бу босқични ўтказиб юбориш',
  },
  captcha: {
    id: 'application_form.captcha',
    defaultMessage: 'Введите ответ примера на картинке',
  },
  close: {
    id: 'application_form.close',
    defaultMessage: 'Назад',
  },
  full_name: {
    id: 'application_form.full_name',
    defaultMessage: 'Ф.И.О',
  },
  feedback_label: {
    id: 'application_form.feedback_label',
    defaultMessage: 'Не нашли свою махаллю?',
  },
  choose_mahalla: {
    id: 'application_form.choose_mahalla',
    defaultMessage: 'Выберите свою махаллю...',
  },
  feedback_title: {
    id: 'application_form.feedback_title',
    defaultMessage: 'Обратная связь',
  },
  feedback_alert: {
    id: 'application_form.feedback_alert',
    defaultMessage: 'Ваше сообщение успешно отправлено !',
  },
  needed_field: {
    id: 'application_form.needed_field',
    defaultMessage: 'Необходимо заполнить поле: {attribute}',
  },
  is_agree: {
    id: 'application_form.is_agree',
    defaultMessage: 'Ознакомлен с отвественностью',
  },
  juridical_tin: {
    id: 'application_form.juridical_tin',
    defaultMessage: 'ИНН',
  },
  get_tin: {
    id: 'application_form.get_tin',
    defaultMessage: 'Получить данные по ИНН',
  },
  check_tin: {
    id: 'application_form.check_tin',
    defaultMessage: 'Проверка ИНН',
  },
  passport: {
    id: 'application_form.passport',
    defaultMessage: 'Паспорт, ID-карта или загранпаспорт гражданина',
  },
  birth_certificate: {
    id: 'application_form.birth_certificate',
    defaultMessage: 'Свидетельство о рождении',
  },
  tin_confirmed: {
    id: 'application_form.tin_confirmed',
    defaultMessage: 'Действительность ИНН подтверждена',
  },
  tin_rejected: {
    id: 'application_form.tin_rejected',
    defaultMessage: 'ИНН не действителен',
  },
  cert_helper_text: {
    id: 'application_form.cert_helper_text',
    defaultMessage: 'Укажите серию и номер свидетельства о рождении',
  },
  address_length: {
    id: 'application_form.address_length',
    defaultMessage: 'Длина адреса не должна превышать 255 символов',
  },
  invalid_type_id: {
    id: 'application_form.invalid_type_id',
    defaultMessage: 'Инвалидность',
  },
  is_collective: {
    id: 'application_form.is_collective',
    defaultMessage: 'Коллективное обращание',
  },
  collection_members_count: {
    id: 'application_form.collection_members_count',
    defaultMessage: 'Количество заявителей',
  },
  collection_members_count_error: {
    id: 'application_form.collection_members_count_error',
    defaultMessage: '«Жамоадаги аъзолар сони» 1 кишидан кўп бўлиши керак',
  },
});



// WEBPACK FOOTER //
// ./src/application-form/messages.js